export default __webpack_public_path__ + "static/zaru_collages_v6-14-719fed57139d13814d4495eb67d7c7ba.png";